export const CAMERA_LOADING_TYPE = 'cameraLoadingType';
export const BLANK_LOADING_TYPE = 'blankLoadingType';
export const HEADER_PAGE_LOADING_TYPE = 'headerPageLoadingType';
